export const formatError = (e: any) => e instanceof Error ? e.message : `${e}`;
